import { awaitRequests, promise } from '../../../helpers';
import { deleteBookFiles } from './index';

const afterDeleteBook = ({ docId, book }) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        if (docId) {
            const reqs = [];

            // delete book files
            reqs.push(dispatch(deleteBookFiles(book)));

            return awaitRequests(reqs);
        }

        return promise();
    };
};

export default afterDeleteBook;
